import { render, staticRenderFns } from "./CompanyTobas.vue?vue&type=template&id=0d7febe1&scoped=true&"
import script from "./CompanyTobas.vue?vue&type=script&lang=js&"
export * from "./CompanyTobas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7febe1",
  null
  
)

export default component.exports